'use client'

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { motion } from 'framer-motion'
import BlogPostCard from '../BlogPostCard'
import client from '../../sanityClient'

const BlogDetails = () => {
  const { slug } = useParams()
  const [blog, setBlog] = useState(null)
  const [loading, setLoading] = useState(true)

  const extractCharacters = (content) => {
    if (!content || content.length === 0) return ''

    const plainText = content
      .filter(block => block._type === 'block')
      .map(block => block.children.map(child => child.text).join(''))
      .join(' ')

    return plainText.substring(0, 100)
  }

  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        const data = await client.fetch(
          `*[_type == "post" && slug.current == $slug]{
            title,
            slug,
            body[] {
              ...,
              _type == "image" => {
                "url": asset->url,
                "alt": asset->altText
              }
            },
            mainImage {
              asset -> {
                _id,
                url
              },
              alt,
            },
            publishedAt,
            author-> {
              name,
              image {
                asset -> {
                  url
                }
              }
            },
            categories[]-> {
              title
            }
          } | order(publishedAt desc)`,
          { slug }
        )

        if (data && data.length > 0) {
          setBlog(data[0])
        } else {
          console.error('No blog found with the given slug:', slug)
        }
      } catch (error) {
        console.error('Error fetching blog details:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchBlogDetails()
  }, [slug])

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <motion.div
          className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full"
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        />
      </div>
    )
  }

  if (!blog) return <div className="text-center text-2xl mt-8">No blog data available</div>

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="container mx-auto px-4 py-8"
    >
      <BlogPostCard
        key={blog?.slug?.current}
        title={blog?.title}
        description={extractCharacters(blog?.body)}
        content={blog?.body || []}
        image={blog?.mainImage?.asset?.url}
        author={blog?.author?.name || 'Unknown Author'}
        authorImage={blog.author?.image?.asset?.url}
        date={blog?.publishedAt}
        categories={blog?.categories.map(cat => cat.title).join(', ')}
      />
    </motion.div>
  )
}

export default BlogDetails